// "Updated <time>" for a live page (ADR-0032): when the engine last published what the page shows, and whether the page follows it
// live (Realtime on the publish signal) or by polling. The time is the engine's publish time, shown in the viewer's clock.
import type { LiveState } from "../../data/live";

export function clockTime(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const time = d.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" });
  return d.toDateString() === now.toDateString() ? time : `${d.toLocaleDateString("en-US", { month: "short", day: "numeric" })}, ${time}`;
}

export function LiveStamp({ live, label = "Updated" }: { live: LiveState; label?: string }) {
  if (live.mode === "loading" || !live.updatedAt) return <span className="text-xs text-muted" data-live="loading">Checking for updates…</span>;
  const how = live.mode === "live" ? "live" : "checks every 30 s";
  const title = live.mode === "live"
    ? "Published by the engine at this time; the page reloads by itself when the engine publishes again."
    : "The publish signal is not available here yet; the page reloads every 30 seconds.";
  return (
    <span className="inline-flex items-center gap-1.5 text-xs text-muted" role="status" aria-live="polite" data-live={live.mode} title={title}>
      <span aria-hidden="true" className={`h-1.5 w-1.5 rounded-full ${live.mode === "live" ? "bg-done" : "bg-waiting"}`} />
      {label} <time dateTime={live.updatedAt}>{clockTime(live.updatedAt)}</time> · {how}
    </span>
  );
}
